// Remarque de Louka du 31/10 : le chat n'a qu'une interface, celle de la page Assistant de l'app (mode
// integre). Ouvert seul (onglet, lien de courriel, « Ouvrir dans un onglet »), il montrait la
// navigation de Dust. Au demarrage, une visite directe repart donc vers la page Assistant de l'app,
// a la meme place quand l'app sait la rouvrir. Ce module pur decide de l'adresse ; meme table que
// `adresseDuHaut` des apps (frontend/src/app/lib/page-nue.ts) : une page de l'app (?page=), une page du
// chat (?chat=), une conversation (?retour=), sinon /assistant.
import { cheminDeLApp, routeDuChat } from "@app/lib/compta/coquille";

const ESPACE = /^\/w\/([A-Za-z0-9]+)(?:\/([^?#]*))?/;
const CONVERSATION = /^conversation\/([A-Za-z0-9_-]+)$/;

/**
 * L'adresse de la page Assistant de l'app pour la route `route` du chat (sans la base /chat), ou null
 * quand la route n'est pas une page d'espace de travail (connexion, erreur, invitation) : celles-la
 * restent affichees telles quelles.
 */
export function adresseDansLApp(route: string, appUrl: string): string | null {
  const m = ESPACE.exec(route);
  if (!m) {
    return null;
  }
  const [, espace, reste = ""] = m;
  if (reste === "join" || reste.startsWith("join/")) {
    return null;
  }
  const assistant = `${appUrl.replace(/\/+$/, "")}/assistant`;
  const requete = route.includes("?")
    ? route.slice(route.indexOf("?") + 1)
    : "";
  if (reste === "app") {
    const page = cheminDeLApp(
      new URLSearchParams(requete.split("#")[0]).get("chemin")
    );
    return page ? `${assistant}?page=${encodeURIComponent(page)}` : assistant;
  }
  if (routeDuChat(reste, espace)) {
    return `${assistant}?chat=${encodeURIComponent(reste)}`;
  }
  const conversation = CONVERSATION.exec(reste);
  if (conversation && conversation[1] !== "new") {
    const chemin = `/chat/w/${espace}/conversation/${conversation[1]}`;
    return `${assistant}?retour=${encodeURIComponent(chemin)}`;
  }
  return assistant;
}

interface FenetreVisite {
  location: { replace: (url: string) => void };
}

/**
 * Au demarrage de la SPA : hors iframe et avec une app configuree, remplace la page par la page
 * Assistant de l'app. Rend true quand la redirection est lancee (ne rien rendre alors).
 */
export function quitterLaVisiteDirecte(
  fenetre: FenetreVisite,
  integre: boolean,
  appUrl: string | null,
  route: string
): boolean {
  if (integre || !appUrl) {
    return false;
  }
  const cible = adresseDansLApp(route, appUrl);
  if (!cible) {
    return false;
  }
  fenetre.location.replace(cible);
  return true;
}
